/** @jsxRuntime classic */
/** @jsx jsx */
import { Text, jsx } from 'theme-ui';
import Icon from 'components/ui-components/icon';
import Link from 'components/ui-components/transition-link';

export const ProjectLinkList = ({ projects = [] }) => {
  return (
    <Text
      as="p"
      data-scroll
      data-scroll-repeat
      data-scroll-speed={1.2}
      sx={{
        marginTop: [0, 4, 5],
        marginBottom: 5,
      }}
    >
      <strong>
        Cases
        <Icon
          symbol="arrow"
          width="1.86ch"
          height="1.4ch"
          sx={{
            marginRight: '1.2rem',
            marginLeft: '1.2rem',
            transform: 'translateY(2px)',
          }}
        />
      </strong>
      {projects.map((proj, i) => {
        return (
          <Link
            skew={false}
            key={proj._id}
            to={`/work/${proj.slug.current}`}
            data-scroll
            data-scroll-repeat
            sx={{
              textDecoration: 'underline',
              marginRight: '1.2rem',
              display: 'inline-block',

              '&:hover': {
                textDecoration: 'none',
              },
            }}
          >
            {proj.title}
          </Link>
        );
      })}
    </Text>
  );
};

export default ProjectLinkList;
